import { combineReducers } from "redux";
import { bookings } from "./bookings";
import { offices as officesReducer } from "./offices";
import { schedules } from "./schedules";
import { timeslots } from "./timeslots";
import { assistantship } from "./assistantship";
import { officePractices } from "./office-practices";
import { createTimeslotsResponse } from "./create-timeslots-response";

export const offices = combineReducers({
  bookings,
  offices: officesReducer,
  schedules,
  timeslots,
  assistants: assistantship,
  officePractices,
  createTimeslotsResponse,
});
